export const privacyUrl = process.env.REACT_SITE_URL + "/privacy-policy-digitalreti/"